import type React from 'react';

import { ListItemText } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';

import CloseIcon from 'assets/icons/icn _ 24px  _ close_empty.svg?react';
import FormErrorMessage from 'components/forms/FormErrorMessage';
import { type PairedParticipantInterface } from 'components/overlays/doubles/types';
import { useStyles } from 'components/panels/doubles/styles';

const eligibilityRules = {
  ntrpTotalExceededNtrpAllowed:
    'Unable to save doubles partners. One of your doubles pairings has exceeded the maximum NTRP rating for the event.',
  ntrpMoreThanOneApart:
    'Unable to save doubles partners. One of your doubles pairings have more than 1 NTRP rating difference between them.',
  ntrpTotalLessThanMinimum:
    'Unable to save doubles partners. One of your doubles pairings does not meet the minimum combined NTRP rating.',
  notEnoughNtrpRatings:
    'Unable to save doubles partners. One of you doubles pairings contains a player without an NTRP rating.',
  unableToDetermineLevelCategory: 'Unable to save doubles partners. We were unable to determine the level category.',
  pairAlreadyExists: 'Pairing already exists',
};

interface PairedPlayersListItemProps {
  participant: PairedParticipantInterface;
  onUnpairParticipant: (participant: PairedParticipantInterface) => void;
}

const PairedPlayersListItem: React.FC<React.PropsWithChildren<PairedPlayersListItemProps>> = ({
  participant,
  onUnpairParticipant,
}) => {
  const { classes } = useStyles();
  const handleOnClick = () => {
    onUnpairParticipant(participant);
  };
  return (
    <ListItem key={participant.individualParticipantsIds[0]} className={classes.listItem}>
      <div>
        <ListItemText
          primary={`${participant.individualParticipants[0] ? participant.individualParticipants[0].name : ''} / ${
            participant.individualParticipants[1] ? participant.individualParticipants[1].name : ''
          }`}
        />
        {!!participant.eligibilityError && (
          <FormErrorMessage message={eligibilityRules[participant.eligibilityError]} />
        )}
      </div>
      <ListItemSecondaryAction>
        <CloseIcon className={classes.closeIcon} height={15} width={15} onClick={handleOnClick} />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default PairedPlayersListItem;
